import supplierRemittanceGenerateMutation from '../../mutations/supplier/SupplierRemittanceGenerateMutation.graphql';
import purchasePaymentRemittanceGenerateMutation from '../../mutations/supplier/PurchasePaymentRemittanceGenerateMutation.graphql';

import * as printFunctions from '../../../actions/supplier/RemittanceAction';
import { supplierDocument } from '../../../utils/mailMergeFields';
import { EntityType } from '../../../@types/entityTypes';
import { DocumentNode } from '@apollo/client';
import { ReportType } from '../../schema/p4types';

const SupplierRemittance: EntityType & {
  generateSuggestPaymentRemittance: DocumentNode;
  generatePurchasePaymentRemittance: DocumentNode;
} = {
  type: 'SupplierRemittance',
  title: 'Remittance Advice',
  generateSuggestPaymentRemittance: supplierRemittanceGenerateMutation,
  generatePurchasePaymentRemittance: purchasePaymentRemittanceGenerateMutation,
  printFunctions: printFunctions,
  configuration: {
    title: 'Remittance Advice',
    reportType: ReportType.SupplierRemittance,
    field: 'remittanceDocumentDefault',
    supplierField: 'supplierRemittanceDocumentDefault',
    receiveFlag: 'receiveRemittanceDocument',
  },
  operations: 0,
  mergeFields: supplierDocument,
};

export default SupplierRemittance;
